var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIconPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 562",
    style: {
      enableBackground: "new 0 0 800 562"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ABD6D0;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M792.9,254.7C707.8,106,563.6,8.3,400,8.3C236.4,8.3,92.2,106,7.1,254.7c-2.3,4-6.8,13.7-7.1,23.5 c-0.3,9.7,3.8,19.4,5.9,23.1C90.9,451,235.6,549.8,400,549.8S709.1,451,794.1,301.2c2.1-3.7,6.1-13.3,5.9-23.1 C799.7,268.5,795.2,258.7,792.9,254.7z M400,462.3c-100.1,0-181.2-81.1-181.2-181.2S299.9,99.9,400,99.9S581.2,181,581.2,281.1 S500.1,462.3,400,462.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400,160.8c-19.7,0-38.1,5.2-54.5,13.7l44.3,100.3l-102-35.9c-4.9,13.1-8,27.2-8,42.1 c0,66.4,53.9,120.2,120.2,120.2c66.4,0,120.2-53.9,120.2-120.2S466.4,160.8,400,160.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconPass);
export default __webpack_public_path__ + "static/media/eye-icon-pass.f69a5c4e2665ae0109d06c8c8a2e6e1f.svg";
export { ForwardRef as ReactComponent };